import axios from 'axios';
export default {
  data() {
    return {
      endpoint: {
        type: String,
        default: null,
      },
    }
  },
  methods: {
    itemInWishlist(item) {
      let wishlist = window.App.get('wishlist.items');
      if(! item.item_type || ! item.item_id) {
        return false;
      }
      return wishlist.some(obj => {
        return obj.item_id == item.item_id && obj.item_type == item.item_type;
      });
    },
    toggleWishlist(item) {
      let wishlist = window.App.get('wishlist.items');
      //serverside toggle
      axios.post(this.endpoint, {
        entity_slug: item.item_type,
        item_id: item.item_id,
      }).then(response => {
        if(response.data.success) {
          //clientside toggle
          const itemIndex = wishlist.findIndex(obj => {
            return obj.item_id == item.item_id && obj.item_type == item.item_type;
          });
          if(itemIndex < 0) {
            wishlist.push(item);
            window.App.UIkit.notification(this.$t('rubinred.wishlist.common.success_adding'), {status: 'success'});
            window.App.$emit('success.rr.wishlistAdd', response.data);
          } else {
            wishlist.splice(itemIndex, 1);
            window.App.UIkit.notification(this.$t('rubinred.wishlist.common.success_removing'), {status: 'success'});
            window.App.$emit('success.rr.wishlistRemove', response.data);
          }
        } else {
          if(response.data.code == "WL_NOT_LOGGED_IN") {
            window.location.href = response.data.login;
          } else {
            window.App.UIkit.notification(response.data.message, {status: 'danger'});
            this.$root.$emit('rubinred.wishlist.toggle.failed', response.data);
          }
        }
      }).catch(error => {
        if(console) console.log(error);
      });
    }
  },
  mounted() {
      this.endpoint = window.App.get('wishlist.endpoint');
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/wishlist/assets/js/mixins/Wishlist.js